var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333.298c.708 0 1.386.274 1.886.762S24 2.21 24 2.899v18.203c0 .69-.281 1.35-.781 1.838s-1.178.762-1.886.762H2.667A2.701 2.701 0 01.78 22.94 2.568 2.568 0 010 21.102V2.899c0-.69.281-1.351.781-1.839A2.702 2.702 0 012.667.298h18.666zm-.666 20.154V13.56a4.186 4.186 0 00-1.273-2.997 4.404 4.404 0 00-3.074-1.241c-1.133 0-2.453.676-3.093 1.69V9.569h-3.72V20.45h3.72v-6.41c0-1 .826-1.82 1.853-1.82.495 0 .97.192 1.32.533.35.342.547.805.547 1.287v6.41h3.72zM5.173 7.526a2.27 2.27 0 001.584-.64c.42-.409.656-.965.656-1.544 0-1.21-1-2.197-2.24-2.197-.597 0-1.17.231-1.593.643a2.17 2.17 0 00-.66 1.554c0 1.21 1.013 2.184 2.253 2.184zm1.854 12.924V9.57H3.333V20.45h3.694z",
    fill: "#FEDF00"
  })));
}

export default SvgLinkedin;